import React, {
  Component,
} from 'react';
import * as Yup from 'yup';
import {
  inject, observer,
} from 'mobx-react';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import {
  WithSnackbarProps,
} from 'notistack';
import {
  withRouter, RouteComponentProps,
} from 'react-router';
import classes from './addEditAdminUsers.module.scss';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import {
  translate,
} from '../../helperFunctions/translation';
import Spinner from '../../components/Spinner';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  IAuthStore,
} from '../../mobx-store/storeInterfaces/authInterface';
import { RolesStore, Role } from '../../mobx-store/stores/rolesStore';
import '../../helperFunctions/yup.custom.validation';

interface Props extends WithSnackbarProps {
  authStore: IAuthStore;
  rolesStore: RolesStore;
  match: any;
  history: any;
}

interface State {
  processing: boolean;
  formFields: FormField[];
  loadingRoles: boolean;
}

@inject('authStore')
@inject('rolesStore')
@observer
class AddEditAdminUsers extends Component<Props & RouteComponentProps, State> {
  emailSuffix = '@wadidegla.com';

  isNew = false;

  eventId = -1;

  lastHistory = -1;

  adminFormTitle = 'Create Admin';

  adminSchema: any;

  submitButton: any;

  cancelButton: any;


  constructor(props: Props & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  componentDidMount() {
    this.getFormData();
  }

  handleSubmit = async (values: any) => {

    console.log(values)
    values.email = `${values.email}${this.emailSuffix}`;
    const {
      history, authStore, rolesStore,
    } = this.props;
   /* const role = rolesStore.roleList.find((role: Role) => role.roleId === values.roleId);
    console.log(role, role.title)
    values.countryId = 1;
    if(role.title.includes('KENYA')){
      values.countryId = 2;
    }*/
    this.setState({
      processing: true,
    });
    authStore.createAdmin(values)
      .then(() => {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
        }), 6000, 'success');
        history.push('/users');
      }).catch((error) => {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(error.response.data.message, 4000, 'error');
      });
  };

  navigateBack = () => {
    const {
      history,
    } = this.props;
    history.goBack();
  };

  getSubmitButton = () => ({
    title: 'Save Changes',
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });

  updateStateWithRolesData = () => {
    const {
      rolesStore,
    } = this.props;
    const {
      roleList,
    } = rolesStore;
    const {
      formFields,
    } = this.state;
    const formFieldsWithData: any[] = [];
    formFields.forEach(field => {
      if (field.name === 'roleId') {
        formFieldsWithData.push({
          ...field, selectList: roleList,
        });
      } else {
        formFieldsWithData.push(field);
      }
    });
    this.setState({
      formFields: formFieldsWithData,
      loadingRoles: false,
    });
  };

  getFormData = () => {
    this.setState({
      loadingRoles: true,
    });
    const {
      rolesStore,
    } = this.props;
    rolesStore.getRoles()
      .then(() => {
        this.updateStateWithRolesData();
      }).catch(() => {
        this.setState({
          loadingRoles: false,
        });
    });
  };

  initState = (isConstructor = true) => {
    const initState: State = {
      processing: false,
      loadingRoles: true,
      formFields: [
        {
          name: 'firstName',
          label: 'First Name',
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'lastName',
          label: 'Last Name',
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'email',
          label: 'Email',
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'phoneNumber',
          label: 'Phone Number',
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'password',
          label: 'Password',
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'roleId',
          label: 'Role',
          selectList: [],
          selectListValue: 'title',
          selectListKey: 'roleId',
          filedType: 'DropdownField',
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };
  initAdminSchema = () => {
    const passwordValidationRegex = /^.*[a-zA-Z]+.*$/;

    this.adminSchema = Yup.object().shape({
      firstName: Yup.string().min(3).max(50).required('Required'),
      lastName: Yup.string().min(3).max(50).required('Required'),
      email: Yup.string().required('Required'),
      phoneNumber: Yup.string().phone().required('Required'),
      // roleId: Yup.string().required('Required'),
      password: Yup.string().min(8).matches(passwordValidationRegex,'password should be alphanumeric').required('Required'),
    });
  };


  initializeComponent(props: Props & RouteComponentProps, isConstructor = true) {
    this.initAdminSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
  }

  render() {
    const {
      processing,
      formFields,
      loadingRoles,
    } = this.state;
    const {
      history,
    } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
        </div>
        <div className={classes.content}>
          {
            loadingRoles
              ? <Spinner />
              : (
                <GeneralFormComponent
                  formTitle={this.adminFormTitle}
                  fields={formFields}
                  formSchema={this.adminSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={processing}
                />
              )
          }
        </div>
      </div>
    );
  }
}

export default withRouter(AddEditAdminUsers);
